<!-- <div class="toolbar-container">
<mat-toolbar class="example-toolbar">
    <span>{{ service.form.controls['id'].value?"Modify PanelMember":"Add Panel Member"}}</span>
    <span class="fill-remaining-space"></span>
    <mat-icon (click)='onClose()'>close</mat-icon>
</mat-toolbar>
</div> -->
<mat-toolbar class="toolbar-example">
    <span>{{ service.form.controls['id'].value?"Modify Panel Members":"Add Panel Members"}}</span>
    <span class="fill-remaining-space"></span>
    <mat-icon style="cursor: pointer;" (click)='onClose()'>close</mat-icon>
</mat-toolbar>

<form [formGroup]="service.form" class="normal-form" (submit)='onSubmit()'>
    <mat-grid-list cols="1" rowHeight="300px">
        <mat-grid-tile>
            <div class="controles-container">
                <input type="hidden" formControlName="id">
                <mat-form-field>
                    <input formControlName="fullName" matInput placeholder="Full name" required>
                    <mat-error *ngIf = "service.form.controls['fullName'].errors?.required" >Name is mandatory.</mat-error>
                    <mat-error *ngIf = "service.form.controls['fullName'].errors?.minlength" >Minimum 3 characters needed.</mat-error>
                </mat-form-field>

                <mat-form-field>
                    <input formControlName="email" matInput placeholder="Email" required>
                    <mat-error *ngIf="service.form.controls['email'].errors?.required">Email address is required</mat-error>
                    <mat-error *ngIf="service.form.controls['email'].errors?.email">Please enter correct email format</mat-error>
                    <mat-icon
                      title="Eg. abc@domain.xy, abc@domain.xy.zp"
                      style="cursor: pointer; vertical-align: bottom; font-size: 20px; color: #252c61;"
                      matSuffix>
                      info
                    </mat-icon>
                </mat-form-field>

                <mat-form-field>
                    <input formControlName="mobile" matInput type="number" placeholder="Mobile" required>
                    <mat-error *ngIf="service.form.controls['mobile'].errors?.required">Contact No is required</mat-error>
                    <mat-error *ngIf="service.form.controls['mobile'].errors?.pattern">Maximum 10 digits are allowed</mat-error>
                </mat-form-field>
            </div>
        </mat-grid-tile>
    </mat-grid-list>
    <div class="button-row">
        <button mat-raised-button class="btn-clear" (click)='onClear()'>Clear</button>
        <button mat-raised-button class="btn-color-example" type="submit" [disabled]="service.form.invalid">Submit</button>
      </div>
</form>